import React from "react";
import { Icons } from "fds";
const utilsDocs = {
  renderDocIcon: (
    name?: string,
    size?: number | string,
    officeType?: "collabora" | "ms365"
  ): React.ReactNode => {
    const fileType = name ? name.substring(name.lastIndexOf(".") + 1) : "";
    if (!!officeType) {
      switch (fileType.toLowerCase()) {
        case "docx":
        case "doc":
        case "docm":
          return (
            <Icons
              variant="document"
              label={officeType === "ms365" ? "officeWord" : "collabWord"}
              size={size}
            />
          );
        case "ppt":
        case "pptx":
          return (
            <Icons
              variant="document"
              label={officeType === "ms365" ? "officePpt" : "collabPpt"}
              size={size}
            />
          );
        case "xls":
        case "xlsx":
          return (
            <Icons
              variant="document"
              label={officeType === "ms365" ? "officeExcel" : "collabExcel"}
              size={size}
            />
          );
        default:
          return <></>;
      }
    }
    switch (fileType.toLowerCase()) {
      case "docx":
      case "doc":
      case "docm":
        return <Icons variant="document" label="word" size={size} />;
      case "ppt":
      case "pptx":
        return <Icons variant="document" label="ppt" size={size} />;
      case "pdf":
        return <Icons variant="document" label="pdf" size={size} />;
      case "xls":
      case "xlsx":
        return <Icons variant="document" label="excel" size={size} />;
      case "hwp":
      case "hwpx":
        return <Icons variant="document" label="hwp" size={size} />;
      case "png":
      case "jpg":
      case "jpeg":
        return <Icons variant="document" label="image" size={size} />;
      case "zip":
        return <Icons variant="document" label="zip" size={size} />;
      case "txt":
        return <Icons variant="document" label="txt" size={size} />;
      case "dwg":
        return <Icons variant="document" label="cad" size={size} />;
      default:
        return <Icons variant="document" label="etc" size={size} />;
    }
  },
  fileSizeFormat: (size?: number, numFixed?: number): string => {
    let result = "";
    if (!size) return "0 bytes";
    const s = ["bytes", "KB", "MB", "GB", "TB", "PB"];
    const e = Math.floor(Math.log(size) / Math.log(1024));

    if (e === -Infinity) {
      result = "0 " + s[0];
    } else {
      result =
        (size / Math.pow(1024, Math.floor(e))).toFixed(numFixed ?? 2) +
        "" +
        s[e];
    }
    return result;
  },
  fileFormattoStr: (fileName?: string): string => {
    const fileType = fileName
      ? fileName.substring(fileName.lastIndexOf(".") + 1)
      : "";

    switch (fileType.toLowerCase()) {
      case "docx":
        return "MS word";
      case "pptx":
        return "MS powerpoint";
      case "pdf":
        return "pdf";
      case "xlsx":
        return "MS excel";
      case "hwp":
        return "Hangul";
      case "png":
        return "PNG";
      case "zip":
        return "ZIP";
      case "txt":
        return "TXT";
      default:
        return "ETC";
    }
  },
  renderDocProgressIcon: (status: string) => {
    switch (status) {
      case "SUCCESS":
        return <Icons variant="fill" label="docSuccess" />;
      case "FAIL":
        return <Icons variant="fill" label="docFail" />;
      case "ING":
        return <Icons variant="fill" label="docLoading" />;
      default:
        return <Icons variant="fill" label="docLoading" percent={0} />;
    }
  },
};

export default utilsDocs;
